/* Chief Angler PDP add-ons for Minimalin (jQuery theme): volume tiers, tap-to-copy offers, sticky ATC, price in ATC button */
(function () {
  function fmtMoney(cents, fmt) {
    fmt = fmt || '₹{{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') { try { return Shopify.formatMoney(cents, fmt); } catch (e) {} }
    var n = cents / 100;
    var two = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var none = Math.round(n).toLocaleString('en-IN');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return k.indexOf('no_decimals') > -1 ? none : two; });
  }
  window.caFmtMoney = fmtMoney;
  // jQuery .trigger('change') does not fire native listeners, so bind both
  function onChange(el, fn) {
    if (!el) return;
    el.addEventListener('change', fn); el.addEventListener('input', fn);
    if (window.jQuery) jQuery(el).on('change', fn);
  }

  if (!customElements.get('ca-volume-tiers')) {
    customElements.define('ca-volume-tiers', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        var self = this;
        var boot = function () { self.setup(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
      }
      setup() {
        this.prices = JSON.parse(this.querySelector('[data-prices]').textContent);
        this.ids = JSON.parse(this.querySelector('[data-ids]').textContent).map(String);
        this.fmt = this.dataset.moneyFormat;
        this.tiers = Array.from(this.querySelectorAll('.ca-vt__tier'));
        this.form = document.getElementById(this.dataset.form);
        this.price = this.prices[0];
        this.idInput = this.form && this.form.querySelector('[name="id"]');
        if (this.idInput) this.setVariant(this.idInput.value);
        this.qtyInput = this.form && this.form.querySelector('input[name="quantity"]');
        if (!this.qtyInput) {
          this.qtyInput = document.createElement('input');
          this.qtyInput.type = 'hidden'; this.qtyInput.name = 'quantity'; this.qtyInput.value = '1';
          this.qtyInput.setAttribute('form', this.dataset.form);
          this.appendChild(this.qtyInput);
        }
        var self = this;
        var refresh = function () { if (self.idInput) self.setVariant(self.idInput.value); self.render(); };
        onChange(this.idInput, function () { setTimeout(refresh, 30); });
        // Minimalin's timber.productPage rewrites #ProductPrice / #AddToCartText on every variant change
        var priceEl = document.getElementById('ProductPrice');
        if (priceEl && window.MutationObserver) new MutationObserver(function () { setTimeout(refresh, 0); }).observe(priceEl, { childList: true, characterData: true, subtree: true });
        this.tiers.forEach(function (t) { t.querySelector('input').addEventListener('change', function () { self.select(t); }); });
        onChange(this.qtyInput, function () { self.render(); });
        if (this.tiers[0]) this.select(this.tiers[0]); else this.render();
      }
      setVariant(id) { var i = this.ids.indexOf(String(id)); if (i > -1) this.price = this.prices[i]; }
      select(tier) {
        tier.querySelector('input').checked = true;
        this.qtyInput.value = tier.dataset.qty;
        this.render();
      }
      currentPct(q) { var pct = 0; this.tiers.forEach(function (t) { if (q >= parseInt(t.dataset.qty, 10)) pct = parseFloat(t.dataset.pct) || 0; }); return pct; }
      render() {
        var self = this;
        var q = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
        var active = null;
        this.tiers.forEach(function (t) {
          var tq = parseInt(t.dataset.qty, 10), p = parseFloat(t.dataset.pct) || 0;
          var unit = self.price - Math.floor(self.price * p / 100);
          t.querySelector('[data-unit]').textContent = fmtMoney(unit, self.fmt);
          if (q >= tq) active = t;
        });
        this.tiers.forEach(function (t) { t.classList.toggle('is-active', t === active); t.querySelector('input').checked = t === active; });
        var pct = this.currentPct(q);
        var unit = this.price - Math.floor(this.price * pct / 100);
        var total = unit * q, full = this.price * q;
        this.querySelector('[data-card-unit]').textContent = fmtMoney(unit, this.fmt);
        this.querySelector('[data-card-total]').textContent = fmtMoney(total, this.fmt);
        var fullEl = this.querySelector('[data-card-full]'), save = this.querySelector('[data-card-save]');
        fullEl.hidden = save.hidden = !(pct > 0);
        fullEl.textContent = fmtMoney(full, this.fmt);
        save.textContent = 'Save ' + fmtMoney(full - total, this.fmt) + ' (' + pct + '%)';
        setAtcLabel(fmtMoney(total, this.fmt));
      }
    });
  }

  // "Add to cart – ₹total" on Minimalin's main button (#AddToCartText)
  function setAtcLabel(total) {
    var btn = document.getElementById('AddToCart');
    var span = document.getElementById('AddToCartText');
    var sp = document.querySelector('ca-sticky-atc [data-sticky-price]');
    if (sp) sp.textContent = total;
    if (!btn || !span || btn.disabled) return;
    var base = (span.textContent || '').split(' – ')[0].trim() || 'Add to cart';
    span.textContent = base + ' – ' + total;
  }

  // Tap-to-copy offer codes
  if (!window.__caCopyBound) {
    window.__caCopyBound = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ca-copy]'); if (!b) return;
      var code = b.getAttribute('data-ca-copy'), lbl = b.querySelector('small');
      var done = function () { if (lbl) { var o = lbl.textContent; lbl.textContent = 'COPIED ✓'; setTimeout(function () { lbl.textContent = o; }, 1800); } };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
  }

  // Sticky ATC / Buy now bar
  if (!customElements.get('ca-sticky-atc')) {
    customElements.define('ca-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        if (this._init) return; this._init = true;
        var self = this;
        var boot = function () { self.setup(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
      }
      setup() {
        var self = this;
        this.mainBtn = document.getElementById('AddToCart');
        if (!this.mainBtn || !window.IntersectionObserver) return;
        this.hidden = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(this.mainBtn);
        this.querySelector('[data-sticky-atc]').addEventListener('click', function () { if (!self.mainBtn.disabled) self.mainBtn.click(); });
        this.querySelector('[data-sticky-buy]').addEventListener('click', function (e) { self.buyNow(e.currentTarget); });
      }
      buyNow(btn) {
        var form = document.getElementById(this.dataset.form); if (!form) return;
        if (this.mainBtn && this.mainBtn.disabled) return;
        btn.setAttribute('aria-disabled', 'true');
        var fd = new FormData(form);
        var body = new FormData();
        body.set('id', fd.get('id'));
        body.set('quantity', fd.get('quantity') || '1');
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body })
          .then(function (r) { return r.json(); })
          .then(function (res) { if (res.status) { alert(res.description || 'Could not add to cart'); btn.removeAttribute('aria-disabled'); return; } window.location.href = '/checkout'; })
          .catch(function () { btn.removeAttribute('aria-disabled'); });
      }
    });
  }
})();
